import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import CartransferFolderForm from "./CartransferFolderForm";
import { getCartransfer } from "../../../api/cartransferService";

const CartransferFolder = ({ cartransferId }) => {
  const [cartransfer, setCartransfer] = useState();
  useEffect(() => {
    const fetchCartransfer = async () => {
      const response = await getCartransfer(cartransferId);
      setCartransfer(response.data);
    };
    fetchCartransfer();
  }, [cartransferId]);

  if (!cartransfer) {
    return <Spin />;
  }

  return <CartransferFolderForm cartransfer={cartransfer} />;
};

export default CartransferFolder;
